import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles"
import { ReactComponent as PurpleStar } from '../../../../assets/images/purple-star.svg'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { OPEN_BANKING_URL } from '../../../../const/URL.const';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        background: 'rgba(79, 60, 201, 0.05)',
        padding: "1.5625rem",
        borderRadius: "1rem",
        "& >p": {
            padding: 0,
            margin: 0
        },
    },
    title: {
        display: "flex",
        flexDirection: "row",
        "& >p": {
            fontFamily: 'Open Sans',
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "1.25rem",
            lineHeight: "1.6875rem",
            color: "#4F3CC9",
            padding: "0 0 0 0.5rem",
            margin:0,
            marginBottom:"0.1875rem"
        }
    },
    infoHeader: {
        fontSize: "1.125rem",
        fontFamily: 'Open Sans',
        fontStyle: "normal",
        lineHeight: "1.625rem",
        fontWeight: 600,
        padding: 0,
        margin: 0
    },
    infoText: {
        fontSize: "0.875rem",
        fontFamily: 'Open Sans',
        fontWeight: 500,
        fontStyle: "normal",
    },
    btn: {
        padding: "0.75rem 0 0.5rem 0 "
    }
})

export function AdvertCard() {
    const { root, title, infoHeader, infoText, btn } = useStyles();
    const history = useHistory();
    const { t } = useTranslation();
    return <div className={root}>
        <div className={title}>
            <PurpleStar />
            <p>{t('openBanking.advert.title')}</p>
        </div>
        <p className={infoHeader}>
            {t('openBanking.advert.infoHeader')}
        </p>
        <p className={infoText}>
            {t('openBanking.advert.infoText')}
        </p>
        <div className={btn}>
            <Button variant="contained" color="secondary" endIcon={<ChevronRightIcon />} onClick={() => history.push(OPEN_BANKING_URL)}>
                {t('openBanking.advert.btn')}
            </Button>
        </div>
    </div>
}